import { render, staticRenderFns } from "./AnomalySummary.vue?vue&type=template&id=f2dd8e7a&scoped=true&"
import script from "./AnomalySummary.vue?vue&type=script&lang=js&"
export * from "./AnomalySummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2dd8e7a",
  null
  
)

export default component.exports